import {VoidFn} from '../../../../types/common/functions/VoidFn';
import {useAutokey} from './useAutokey';

export function useEsc(handler?: VoidFn) {
    useAutokey({key: 'Escape'}, handler);
}
